/* eslint-disable no-inline-comments */
/* eslint-disable capitalized-comments */
// ========================= IMPORT DEPENDENCIES ========================= //

import {bootstrap} from '@mvps-genesis/bootstrap';
import Global from 'pages/Global';

// ========================= RUN MAIN SCRIPT ========================= //

bootstrap({

	// Pass your MVT to JS namespace
	context: window.mivaJS,

	// Global Page class
	globalClass: Global,

	// A directory of page classes or scss files to be loaded by matching the `Page_Code` context variable
	pageCodeImports: {
		ABAL: () => import(/* webpackChunkName: "page-code--ABAL" */'pages/ABAL/ABAL.js'),
		ACAD: () => import(/* webpackChunkName: "page-code--ACAD" */'pages/ACAD/ACAD.js'),
		ACED: () => import(/* webpackChunkName: "page-code--ACED" */'pages/ACED/ACED.js'),
		ACLN: () => import(/* webpackChunkName: "page-code--ACLN" */'pages/ACLN/ACLN.js'),
		AFAD: () => import(/* webpackChunkName: "page-code--AFAD" */'pages/AFAD/AFAD.js'),
		AFCL: () => import(/* webpackChunkName: "page-code--AFCL" */'pages/AFCL/AFCL.js'),
		AFED: () => import(/* webpackChunkName: "page-code--AFED" */'pages/AFED/AFED.js'),
		AFFR: () => import(/* webpackChunkName: "page-code--AFFR" */'pages/AFFR/AFFR.js'),
		AFPW: () => import(/* webpackChunkName: "page-code--AFPW" */'pages/AFPW/AFPW.js'),
		AFRT: () => import(/* webpackChunkName: "page-code--AFRT" */'pages/AFRT/AFRT.js'),
		ATKA: () => import(/* webpackChunkName: "page-code--ATKA" */'pages/ATKA/ATKA.js'),
		ATKE: () => import(/* webpackChunkName: "page-code--ATKE" */'pages/ATKE/ATKE.js'),
		ATKS: () => import(/* webpackChunkName: "page-code--ATKS" */'pages/ATKS/ATKS.js'),
		BASK: () => import(/* webpackChunkName: "page-code--BASK" */'pages/BASK/BASK.js'),
		CABK: () => import(/* webpackChunkName: "page-code--CABK" */'pages/CABK/CABK.js'),
		CADA: () => import(/* webpackChunkName: "page-code--CADA" */'pages/CADA/CADA.js'),
		CADE: () => import(/* webpackChunkName: "page-code--CADE" */'pages/CADE/CADE.js'),
		CARS: () => import(/* webpackChunkName: "page-code--CARS" */'pages/CARS/CARS.js'),
		CARV: () => import(/* webpackChunkName: "page-code--CARV" */'pages/CARV/CARV.js'),
		CEML: () => import(/* webpackChunkName: "page-code--CEML" */'pages/CEML/CEML.js'),
		CPCA: () => import(/* webpackChunkName: "page-code--CPCA" */'pages/CPCA/CPCA.js'),
		CPCD: () => import(/* webpackChunkName: "page-code--CPCD" */'pages/CPCD/CPCD.js'),
		CPCE: () => import(/* webpackChunkName: "page-code--CPCE" */'pages/CPCE/CPCE.js'),
		CPWD: () => import(/* webpackChunkName: "page-code--CPWD" */'pages/CPWD/CPWD.js'),
		CSBE: () => import(/* webpackChunkName: "page-code--CSBE" */'pages/CSBE/CSBE.js'),
		CSTR: () => import(/* webpackChunkName: "page-code--CSTR" */'pages/CSTR/CSTR.js'),
		CSUB: () => import(/* webpackChunkName: "page-code--CSUB" */'pages/CSUB/CSUB.js'),
		CTGY_STORE: () => import(/* webpackChunkName: "page-code--CTGY_STORE" */'pages/CTGY_STORE/CTGY_STORE.js'),
		CTLG: () => import(/* webpackChunkName: "page-code--CTLG" */'pages/CTLG/CTLG.js'),
		CTUS: () => import(/* webpackChunkName: "page-code--CTUS" */'pages/CTUS/CTUS.js'),
		DONATIONS: () => import(/* webpackChunkName: "page-code--DONATIONS" */'pages/DONATIONS/DONATIONS.js'),
		GFTL: () => import(/* webpackChunkName: "page-code--GFTL" */'pages/GFTL/GFTL.js'),
		GIFTCARDS: () => import(/* webpackChunkName: "page-code--GIFTCARDS" */'pages/GIFTCARDS/GIFTCARDS.js'),
		HMKT: () => import(/* webpackChunkName: "page-code--HMKT" */'pages/HMKT/HMKT.js'),
		INVC: () => import(/* webpackChunkName: "page-code--INVC" */'pages/INVC/INVC.js'),
		ISPU: () => import(/* webpackChunkName: "page-code--ISPU" */'pages/ISPU/ISPU.js'),
		LOGN: () => import(/* webpackChunkName: "page-code--LOGN" */'pages/LOGN/LOGN.js'),
		NTFD: () => import(/* webpackChunkName: "page-code--NTFD" */'pages/NTFD/NTFD.js'),
		OCST: () => import(/* webpackChunkName: "page-code--OCST" */'pages/OCST/OCST.js'),
		OPAY: () => import(/* webpackChunkName: "page-code--OPAY" */'pages/OPAY/OPAY.js'),
		ORDH: () => import(/* webpackChunkName: "page-code--ORDH" */'pages/ORDH/ORDH.js'),
		ORDL: () => import(/* webpackChunkName: "page-code--ORDL" */'pages/ORDL/ORDL.js'),
		ORDS: () => import(/* webpackChunkName: "page-code--ORDS" */'pages/ORDS/ORDS.js'),
		ORHL: () => import(/* webpackChunkName: "page-code--ORHL" */'pages/ORHL/ORHL.js'),
		OSEL: () => import(/* webpackChunkName: "page-code--OSEL" */'pages/OSEL/OSEL.js'),
		PLST: () => import(/* webpackChunkName: "page-code--PLST" */'pages/PLST/PLST.js'),
		PREFCENTER: () => import(/* webpackChunkName: "page-code--PREFCENTER" */'pages/PREFCENTER/PREFCENTER.js'),
		RETURNS: () => import(/* webpackChunkName: "page-code--RETURNS" */'pages/RETURNS/RETURNS.js'),
		RGFT: () => import(/* webpackChunkName: "page-code--RGFT" */'pages/RGFT/RGFT.js'),
		SMAP: () => import(/* webpackChunkName: "page-code--SMAP" */'pages/SMAP/SMAP.js'),
		SRCH: () => import(/* webpackChunkName: "page-code--SRCH" */'pages/SRCH_SS/SRCH_SS.js'),
		WISH: () => import(/* webpackChunkName: "page-code--WISH" */'pages/WISH/WISH.js'),
		WLAD: () => import(/* webpackChunkName: "page-code--WLAD" */'pages/WLAD/WLAD.js'),
		WLED: () => import(/* webpackChunkName: "page-code--WLED" */'pages/WLED/WLED.js'),
		WLGN: () => import(/* webpackChunkName: "page-code--WLGN" */'pages/WLGN/WLGN.js'),
		WLST: () => import(/* webpackChunkName: "page-code--WLST" */'pages/WLST/WLST.js'),
		stores: () => import(/* webpackChunkName: "page-code--stores" */'pages/STORES/STORES.js')
	},

	// A directory of page classes or scss files to be loaded by matching the `Screen` or `Page_Code` context variable against a regular expression
	regexImports: {
		'/^SFNT/i': () => import(/* webpackChunkName: "page-code--SFNT" */'pages/SFNT/SFNT.js')
	},

	// A directory of page classes or scss files to be loaded by matching the `Screen` context variable
	screenImports: {
		CTGY: () => import(/* webpackChunkName: "page-code--CTGY" */'pages/CTGY_SS/CTGY_SS.js'),
		PROD: () => import(/* webpackChunkName: "page-code--PROD" */'pages/PROD/PROD.js')
	}

});
